import { ReactNode } from 'react';

/**
 * Checkbox stylisée — remplace MUI Checkbox + FormControlLabel.
 */
const Checkbox = (props: {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: ReactNode;
    disabled?: boolean;
    className?: string;
}) => (
    <label className={`inline-flex items-center gap-2 select-none ${props.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${props.className || ''}`}>
        <input
            type="checkbox"
            checked={props.checked}
            disabled={props.disabled}
            onChange={(e) => props.onChange(e.target.checked)}
            className="w-4 h-4 rounded border-[var(--eb-border)] text-[var(--eb-primary)] accent-[var(--eb-primary)] focus:ring-2 focus:ring-[var(--eb-primary)]/40 cursor-pointer disabled:cursor-not-allowed"
        />
        {props.label && <span className="text-sm text-[var(--eb-text)]">{props.label}</span>}
    </label>
);

export default Checkbox;
